import { PromissoryNoteField } from './components/PromissoryNoteField';
import { ApprovedLoanAmountField } from './components/ApprovedLoanAmountField';
import { InterestRateField } from './components/InterestRateField';
import { InterestAccrualField } from './components/InterestAccrualField';
import { InterestRateFloorField } from './components/InterestRateFloorField';
import { InterestRateCeilingField } from './components/InterestRateCeilingField';
import { ReserveRateField } from './components/ReserveRateField';
import { GradeField } from './components/GradeField';
import { UnderwritingFeeField } from './components/UnderwritingFeeField';
import { OriginationFeeField } from './components/OriginationFeeField';
import { BrokerShareField } from './components/BrokerShareField';
import { BrokerSharePercentField } from './components/BrokerSharePercentField';
import { BrokerAdditionalField } from './components/BrokerAdditionalField';
import { BrokerAdditionalPercentField } from './components/BrokerAdditionalPercentField';
import { LiquidityField } from './components/LiquidityField';
import { ItemRow } from '../../../ItemRow/ItemRow';

/** The Loan step's fields for a Model loan. Every standard Loan field, including Interest Rate Floor/Ceiling. */
export const ModelPanel = () => {
    return (
        <>
            <ItemRow>
                <PromissoryNoteField />
                <ApprovedLoanAmountField />
            </ItemRow>
            <ItemRow>
                <InterestRateField />
                <InterestAccrualField />
            </ItemRow>
            <ItemRow>
                <InterestRateFloorField />
                <InterestRateCeilingField />
            </ItemRow>
            <ItemRow>
                <ReserveRateField />
                <GradeField />
            </ItemRow>
            <ItemRow>
                <UnderwritingFeeField />
                <OriginationFeeField />
            </ItemRow>
            <ItemRow>
                <BrokerShareField />
                <BrokerSharePercentField />
            </ItemRow>
            <ItemRow>
                <BrokerAdditionalField />
                <BrokerAdditionalPercentField />
            </ItemRow>
            <ItemRow
                columnSpan={1}
                totalTableColumns={2}
            >
                <LiquidityField />
            </ItemRow>
        </>
    );
};
